// @flow
import React from "react";
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons";

import FontAwesomeIcon from "../FontAwesomeIcon";
import getSizeClass from "../../../helpers/getFontAwesomeSizeClassname";

type Props = {
  size?: 16 | 24 | 32 | 40,
  className?: string
};

const ArrowRight = ({ size, className }: Props) => {
  const sizeClass = getSizeClass(size);

  return (
    <div className={`${sizeClass} ${className}`}>
      <FontAwesomeIcon icon={faArrowRight} />
    </div>
  );
};

export default ArrowRight;
